module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ab94bce18038d46772c4c013b18c50d8.png";